{
  "generic": "Something went wrong",
  "unknownError": "An unexpected error occurred.",
  "requestFailed": "Request failed",
  "spinFailed": "Spin failed",
  "lockUpdateFailed": "Could not update lock",
  "submitFailed": "Submit failed",
  "picksOutOfSync": "Your picks just updated, please try again.",
  "spinReturned": "A game in your picks has already started. That reel is unlocked and you have a spin back."
}
